var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 14.833,
    viewBox: "0 0 13.5 14.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-trash-2",
    "data-name": "Icon feather-trash-2",
    transform: "translate(-1.25 -0.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35690",
    "data-name": "Path 35690",
    d: "M2,4H14",
    fill: "none",
    stroke: "#ef466f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35691",
    "data-name": "Path 35691",
    d: "M12.667,4v9.333a1.333,1.333,0,0,1-1.333,1.333H4.667a1.333,1.333,0,0,1-1.333-1.333V4m2,0V2.667A1.333,1.333,0,0,1,6.667,1.333H9.333a1.333,1.333,0,0,1,1.333,1.333V4",
    fill: "none",
    stroke: "#ef466f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35692",
    "data-name": "Path 35692",
    d: "M6.667,7.333v4",
    fill: "none",
    stroke: "#ef466f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35693",
    "data-name": "Path 35693",
    d: "M9.333,7.333v4",
    fill: "none",
    stroke: "#ef466f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f5305bc7fb20ac4bb2ccaa70af561c0d.svg";
export { ForwardRef as ReactComponent };